import Cookie from 'js-cookie';
import config from '../api/config';
export default {
  data() {
    return {
      resourcesVal: "",
      inited: false,
      path: config.path
    };
  },
  props: {
    value: {
      default: '',
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
    fullUrl: {
      default: false,
      type: Boolean
    },
    // 投诉建议标识
    complaints: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (!oldVal && newVal && !this.inited) {
        this.resourcesVal = newVal;
        this.inited = true;
      }
    }
  },
  computed: {
    token() {
      return localStorage.accessToken;
    }
  },
  methods: {
    // 文件/图片上传
    handleUploadSuccess(response, file, fileList) {
      this.inited = true;
      this.resourcesVal = file.response.resourcesUrl + file.response.filePath;
      if (this.fullUrl) {
        this.$emit('input', this.resourcesVal);
      } else {
        this.$emit('input', file.response.filePath);
      }
    },
    // 限制图片上传大小
    beforeAvatarUpload(file) {
      if (this.complaints) {
        // 投诉建议文件大小判断
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
          this.$message.error('文件大小不能超过6M');
          return false;
        }
      } else {
        // 支付凭证文件大小判断
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('文件大小不能超过2M');
          return false;
        }
      }

      // 判断文件/图片类型来筛选图片格式上传
      let _type = file.type;
      if (_type.indexOf('png') == -1 && _type.indexOf('jpg') == -1 && _type.indexOf('jpeg') == -1) {
        this.$message.error('文件格式不正确');
        return false;
      }
      return;
    },
    // 投诉建议删除上传附件
    handleRemove(file, fileList) {
      this.$refs.upload.clearFiles();
      this.resourcesVal = "";
      if (this.fullUrl) {
        this.$emit('input', '');
      } else {
        this.$emit('input', '');
      }
    }
  }
};